export enum FetchStatus {
    PENDING,
    SUCCESS,
    FAILED,
}